import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromKeg from 'app/state/keg';

export const kegDetailResolverFn: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  store.dispatch(fromKeg.setItem({ id: route.params['id'] ?? '' }));
  return true;
};
